"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimecardStatus = exports.DisputeStatus = exports.AdjustmentType = exports.FundingSourceStatus = exports.AgencyPayoutStatusEnum = exports.PayoutStatusEnum = exports.JobBillingCategory = void 0;
var JobBillingCategory;
(function (JobBillingCategory) {
    JobBillingCategory["Standard"] = "standard";
    JobBillingCategory["Disputable"] = "disputable";
})(JobBillingCategory = exports.JobBillingCategory || (exports.JobBillingCategory = {}));
var PayoutStatusEnum;
(function (PayoutStatusEnum) {
    PayoutStatusEnum["Canceled"] = "canceled";
    PayoutStatusEnum["Paid"] = "paid";
    PayoutStatusEnum["Hold"] = "hold";
    PayoutStatusEnum["Failed"] = "failed";
    PayoutStatusEnum["InTransit"] = "in_transit";
    PayoutStatusEnum["Approved"] = "approved";
    PayoutStatusEnum["Open"] = "open";
    PayoutStatusEnum["Pending"] = "pending";
    PayoutStatusEnum["Submitted"] = "submitted";
})(PayoutStatusEnum = exports.PayoutStatusEnum || (exports.PayoutStatusEnum = {}));
var AgencyPayoutStatusEnum;
(function (AgencyPayoutStatusEnum) {
    AgencyPayoutStatusEnum["Canceled"] = "canceled";
    AgencyPayoutStatusEnum["Paid"] = "paid";
    AgencyPayoutStatusEnum["Failed"] = "failed";
    AgencyPayoutStatusEnum["Pending"] = "pending";
    AgencyPayoutStatusEnum["Processing"] = "processing";
})(AgencyPayoutStatusEnum = exports.AgencyPayoutStatusEnum || (exports.AgencyPayoutStatusEnum = {}));
var FundingSourceStatus;
(function (FundingSourceStatus) {
    FundingSourceStatus["Active"] = "active";
    FundingSourceStatus["FailedSetup"] = "failed_setup";
    FundingSourceStatus["Inactive"] = "inactive";
    FundingSourceStatus["Processing"] = "processing";
})(FundingSourceStatus = exports.FundingSourceStatus || (exports.FundingSourceStatus = {}));
var AdjustmentType;
(function (AdjustmentType) {
    AdjustmentType["BONUS"] = "bonus";
    AdjustmentType["COLLECTIONS_LATE_FEE"] = "collections_late_fee";
    AdjustmentType["CREDIT_ADJUSTMENT"] = "credit_adjustment";
    AdjustmentType["CREDIT_TRANSFER"] = "credit_transfer";
    AdjustmentType["HOURLY_FACILITY_INITIATED_ADJUSTMENT"] = "hourly_facility_initiated_adjustment";
    AdjustmentType["HOURLY_PRO_INITIATED_ADJUSTMENT"] = "hourly_pro_initiated_adjustment";
    AdjustmentType["HOURLY_OTHER"] = "hourly";
    AdjustmentType["INVOICING_FEE"] = "invoicing_fee";
    AdjustmentType["PROCESSING_FEE"] = "processing_fee";
    AdjustmentType["PARKING_REIMBURSEMENT"] = "parking_reimbursement";
    AdjustmentType["ORIENTATION"] = "orientation";
    AdjustmentType["OPT_OUT"] = "opt_out";
    AdjustmentType["VMS_FEE"] = "vms_fee";
    AdjustmentType["REBATE_PROMO_CREDIT"] = "rebate_promo_credit";
    AdjustmentType["REBATE_FOUR_HOUR_MINIMUM"] = "rebate_4hour_minimum";
    AdjustmentType["REBATE_LATE_CANCELLATION"] = "rebate_late_cancellation";
    AdjustmentType["REBATE_BETTER_PRO_EXPERIENCE"] = "rebate_better_pro_experience";
    AdjustmentType["REBATE_OTHER"] = "rebate";
    AdjustmentType["EDUCATION_STIPEND"] = "education_stipend";
    AdjustmentType["SHORT_PAY"] = "short_pay";
    AdjustmentType["CANCELLATION_FEE"] = "cancellation_fee";
    AdjustmentType["EARLY_PAYMENT_DISCOUNT"] = "early_payment_discount";
    AdjustmentType["OTHER_FEES"] = "other_fees";
    AdjustmentType["WRITE_OFF_RECOVERY"] = "wo_recovery";
    AdjustmentType["MEAL_PENALTY_FEE"] = "meal_penalty_fee";
    AdjustmentType["SCHEDULING_ASSURENCE"] = "scheduling_assurance";
})(AdjustmentType = exports.AdjustmentType || (exports.AdjustmentType = {}));
var DisputeStatus;
(function (DisputeStatus) {
    DisputeStatus["New"] = "new";
    DisputeStatus["InProgress"] = "in_progress";
    DisputeStatus["OnHold"] = "on_hold";
    DisputeStatus["Resolved"] = "resolved";
    DisputeStatus["RequireFacilityEmail"] = "require_facility_email";
    DisputeStatus["WaitingForProToRespond"] = "waiting_for_pro_to_respond";
    DisputeStatus["NeedsAdditionalReview"] = "needs_additional_review";
    DisputeStatus["Form530UploadedAndNeedsReview"] = "530_uploaded_and_needs_review";
})(DisputeStatus = exports.DisputeStatus || (exports.DisputeStatus = {}));
var TimecardStatus;
(function (TimecardStatus) {
    TimecardStatus["Open"] = "open";
    TimecardStatus["Submitted"] = "submitted";
    TimecardStatus["Approved"] = "approved";
})(TimecardStatus = exports.TimecardStatus || (exports.TimecardStatus = {}));
